import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetWhishlistedHolidaysQuery } from '@api/whishlists.api';
import {
  Center,
  Container,
  Grid,
  Loader,
  Stack,
  Text,
  Title,
} from '@mantine/core';

import WishListCard from './wishListCard/WishListCard';

export default function WishList() {
  const { t } = useTranslation();

  const { data = [], isLoading } = useGetWhishlistedHolidaysQuery();

  const title = useMemo(
    () => `${t('wishlist.title')} ${data.length > 0 ? `(${data.length})` : ''}`,
    [data.length, t],
  );

  return (
    <Container mt={{ base: 'md', xs: 0 }}>
      {isLoading ? (
        <Center>
          <Loader />
        </Center>
      ) : data.length > 0 ? (
        <>
          <Title mb="md" order={2}>
            {title}
          </Title>

          <Grid>
            {data.map((ws) => (
              <Grid.Col span={{ xs: 6, sm: 4, span: 12 }} key={ws.id}>
                <WishListCard data={ws} />
              </Grid.Col>
            ))}
          </Grid>
        </>
      ) : (
        <Stack align="center" justify="center" gap="md">
          <Text fz="lg" fs="italic">
            {t('wishlist.empty')}
          </Text>
        </Stack>
      )}
    </Container>
  );
}
